import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import { Box, IconButton,InputAdornment, TextField, Tooltip, Typography } from '@mui/material';
import { Theme, useMediaQuery } from '@mui/system';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { countWords, gotoLogin } from '@/features/Functions/ResultFunctions';

// Props Interface
interface TextInputWithWordCountProps {
  inputText: string;
  setInputText: (text: string) => void;
  placeholderText?: string;
  isTouched: boolean;
  inputRef?: React.Ref<any>;
  handlePaste: (setInputText: (text: string) => void) => void;
}

// Max words allowed
const MAX_WORDS = 600;

// Component
const TextInputWithWordCount: React.FC<TextInputWithWordCountProps> = ({
                                                                         inputText,
                                                                         setInputText,
                                                                         placeholderText ,
                                                                         isTouched,
                                                                         inputRef,
                                                                         handlePaste,
                                                                       }) => {

  // Handle text change with word count limit
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const newText = e.target.value;
    const wordCount = countWords(newText);

    // Only set the input text if it does not exceed the max word count
    if (wordCount <= MAX_WORDS) {
      setInputText(newText); // Correctly updates state
    }
  };
  const isSmallScreen = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', position: 'relative' }}>

      {/* Word Count */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.5rem', paddingBottom: '0.5rem' }}>
        <Tooltip title={<FormattedMessage id="home.text-generator.Result.wordcount" />} arrow>
          <Typography variant="body2" color="textSecondary" sx={{ fontSize: { xs: '0.75rem', sm: '0.875rem' } }}>
            {countWords(inputText)} / {MAX_WORDS} <FormattedMessage id="home.text-generator.Result.word" />

          </Typography>
        </Tooltip>
      </Box>

      {/* Text Input */}
      <TextField
        placeholder={placeholderText}
        variant="outlined"
        value={inputText}
        fullWidth
        multiline
        rows={isSmallScreen ? 4 : 7}
        onChange={handleChange} // Correctly handles text change with word count limit
        error={isTouched && !inputText}
        helperText={
          isTouched && !inputText
            ? <FormattedMessage id="home.text-generator.textarea.error" />
            : countWords(inputText) >= MAX_WORDS
              ? (
                <>
                  <FormattedMessage id="home.textarea.maxWordsError" />
                  {' '}
                  <span
                    style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}
                    onClick={gotoLogin}
                  >
            <FormattedMessage id="home.text-generator.signupnow" />
          </span>
                </>
              )
              : ''
        }
        inputRef={inputRef}
        InputProps={{
          endAdornment: !inputText && (
            <InputAdornment
              position="end"
              sx={{
                position: 'absolute',
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -50%)',
                zIndex: 10,
              }}
            >
              <IconButton onClick={() => handlePaste(setInputText)}   sx={{
                ':hover': { backgroundColor: 'transparent' }, // Removes hover background
              }}> {/* Handles pasting */}
                <FormattedMessage id="home.text-Paraphraser.past" />
                <ContentPasteIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

export default TextInputWithWordCount;
